module.exports = __webpack_public_path__ + "static/img/product.e3551fd0.png";